import Vue from "vue";
import Router from "vue-router";
import Index from "@/views/index/index.vue";


Vue.use(Router);

const constantRoutes = [{
  path: "/",
  name: "index",
  component: Index
}
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router